import * as yup from 'yup';

const EditVendorvalidationSchema = yup.object().shape({
  business_name: yup.string()
    .matches(/^[a-zA-Z0-9\s]+$/, 'Business Name can only contain letters, numbers, and spaces (e.g., "My Business 123")')
    .required('Business Name is required'),
  business_type: yup.string().required('Business Type is required'),
  business_category: yup.string().required('Business Category is required'),
  owner_name: yup.string()
    .matches(/^[a-zA-Z\s]+$/, 'Owner Name can only contain letters and spaces (e.g., "John Doe")')
    .required('Owner Name is required'),
  email: yup.string()
    .email('Invalid email format (e.g., "example@domain.com")')
    .required('Email is required'),
  mobile_number: yup.string()
    .matches(/^[0-9]{10}$/, 'Mobile Number must be 10 digits (e.g., "1234567890")')
    .required('Mobile Number is required'),
  password: yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
  account_number: yup.string()
    .matches(/^[0-9]{9,18}$/, 'Account Number must be between 9 and 18 digits (e.g., "123456789")')
    .required('Account Number is required'),
  ifsc_code: yup.string()
    .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC Code format (e.g., "ABCD0123456")')
    .required('IFSC Code is required'),
  passbook_name: yup.string()
    .matches(/^[a-zA-Z\s]+$/, 'Passbook Name can only contain letters and spaces (e.g., "John Doe")')
    .required('Passbook Name is required'),
  pan_card_number: yup.string()
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Card Number format (e.g., "ABCDE1234F")')
    .required('PAN Card Number is required'),
  gst: yup.string()
    .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, 'Invalid GST Number format (e.g., "22AAAAA0000A1Z5")')
    ,
});

export default EditVendorvalidationSchema;